<template>
  <NuxtLayout name="search-basic-layout">
    <ArticleTemplate>
      <div class="mb-3">
        <h1 class="text-[32px] text-osn-grey-00 font-medium">{{ $t('article.recent_articles') }}</h1>
      </div>
      <ul class="flex flex-wrap justify-center gap-6">
        <li v-for="article in state.blogArticle"
            class="mb-6 w-full lg:w-[calc(33.333%-16px)]
            xl:w-[calc(25%-18px)] pc:max-w-[320px]"
            ref="articleRefs">
          <NuxtLink :to="'/blog/'+article.static_url">
            <div class="h-[44px]"><h3 class="text-[18px] mt-2 font-semibold leading-snug line-clamp-2">{{ article.subject }}</h3></div>
          </NuxtLink>
          <p class="mb-3 text-osn-grey-01 text-base">{{ article.begin_time.split(" ")[0] }}</p>
          <NuxtLink :to="'/blog/'+article.static_url">
            <div class="flex justify-center">
              <img class="w-full h-[200px] object-cover rounded-md"
                   :src="picUrl+article.photo_url"
                   :alt="article.subject">
            </div>
          </NuxtLink>
          <div class="mt-[35px] leading-8 text-lg">
            <p>{{ article.data3 }}</p>
            <NuxtLink :to="'/blog/'+article.static_url"><p class="text-right">{{
                $t('article.read_more')
              }}</p></NuxtLink>
          </div>

        </li>
      </ul>
      <div class="mt-5 mb-10">
        <el-pagination :background="true"
                       hide-on-single-page
                       :current-page="state.currentPage"
                       @current-change="handlePaginationChange"
                       layout="prev, pager, next"
                       :page-size="state.pageLimit"
                       :total="state.total"/>
      </div>
    </ArticleTemplate>
  </NuxtLayout>
</template>

<script setup
        lang="ts">
definePageMeta(
    {title: '最新場地筆記'}
)


import {ref, reactive, useTemplateRef} from "vue";
import ArticleTemplate from "@/components/SearchIndex/BlogArticle/ArticleTemplate.vue";
import {getBlogArticle} from "@/api/banner";
import type {Article} from '~/utils/types';

const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL

const state = reactive({
  blogArticle: [] as Article[],
  total: 0,
  currentPage: ref(1),
  pageLimit: ref(50),
});
const articleRefs = useTemplateRef('articleRefs');

const {data: blogArticleData} = await useAsyncData(
    'blogArticleData',
    () => getBlogArticle(state.pageLimit, 1));

if (blogArticleData.value) {
  state.total = blogArticleData.value.total;

  state.blogArticle = blogArticleData.value.list;
}


const seoMeta = {
  title: '場地租借、會議室預約指南與空間管理秘訣|空間便利店場地筆記',
  description: '【空間便利店場地筆記】分享場地租借攻略與空間管理秘訣，涵蓋共享辦公室、活動會場、會議室、餐廳app等實用預約教學指南，幫助房東快速上架並提升出租效率，滿足您對場地的各類需求。',
  ogTitle: '空間便利店 空間文章｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogSiteName: '空間便利店',
  ogDescription: '【空間便利店場地筆記】分享場地租借攻略與空間管理秘訣，涵蓋共享辦公室、活動會場、會議室、餐廳app等實用預約教學指南，幫助房東快速上架並提升出租效率，滿足您對場地的各類需求。',
  ogUrl: 'https://www.onestep.place',
  ogType: 'website',
  ogImage: 'https://pic.onestep.place/images/onestep-og.png',
  ogImageAlt: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約'
};

useSeoMeta(seoMeta);

const handlePaginationChange = async (page: number) => {
  state.currentPage = page;
  const res = await getBlogArticle(state.pageLimit, page);
  if (res) {
    state.total = res.total;
    state.blogArticle = res.list;
    articleRefs.value[0].scrollIntoView();

  }
};

</script>

<style scoped
       lang="scss">
:deep(.el-pagination) {

  .el-pager li:not(.disabled).is-active {
    @apply bg-osn-yellow-02 text-osn-dark-grey-00 border-osn-yellow-00;
  }

  .el-pager li:not(.is-active):hover,
  .btn-next:hover,
  .btn-prev:hover {
    @apply text-osn-yellow-00 border-osn-yellow-00;
  }

}

</style>
